// Every row begins with a snapshot of the caller's UserSettings (currency +
// tax regime), then invoice-level fields — mirroring the columns
// `invoices_slice_by_range` returns, in the same order.
const userContext = {
  userCurrency: 'GEL',
  userTaxFee: '1',
  userTaxBase: 'turnover',
  userAccountingBasis: 'cash',
  userVatStatus: 'notRegistered',
  userVatBasis: 'invoice',
  userVatThreshold: '100000',
  userVatThresholdWindow: 'rolling12Months',
};

const invoicesRows: ReadonlyArray<Record<string, string | null>> = [
  {
    ...userContext,
    invoiceId: 'KqKVhzyHHq2StCc9jbLf',
    invoiceDate: '2022-01-31',
    invoiceNumber: '2',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    paidAmount: '1000.00',
    paidAmountInCurr: '2986.70',
    totalWithheld: '0.00',
    totalWithheldInCurr: '0.00',
  },
  {
    ...userContext,
    invoiceId: '2WUWx9RkulxrmMuPQCcb',
    invoiceDate: '2022-02-28',
    invoiceNumber: '3',
    invoiceAmountRaw: '1000.00',
    invoiceAmount: '1000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    paidAmount: '1000.00',
    paidAmountInCurr: '3274.40',
    totalWithheld: '0.00',
    totalWithheldInCurr: '0.00',
  },
  {
    ...userContext,
    invoiceId: '8yYW320fAfIbkZEpvDau',
    invoiceDate: '2022-03-31',
    invoiceNumber: '4',
    invoiceAmountRaw: '2000.00',
    invoiceAmount: '2000.00',
    invoiceVat: '0.00',
    customer: 'JPMORGAN CHASE BANK N.A.',
    paidAmount: '2000.00',
    paidAmountInCurr: '6180.40',
    totalWithheld: '0.00',
    totalWithheldInCurr: '0.00',
  },
];

const invoicesQuery = `
  SELECT
  * FROM
  \`invoicemaker-f5e1d.mini_accountant.invoices_slice_by_range\`(
    PARSE_TIMESTAMP("%Y%m%d",  "20220101", "Asia/Tbilisi"),
    PARSE_TIMESTAMP("%Y%m%d", "20231231", "Asia/Tbilisi"),
    "Asia/Tbilisi"
  );
  `;

export { invoicesRows, invoicesQuery };
